const initialState = {
  theMonth: 1,
  months:[
    {
      title: "Januari",
      shortTitle: "Jan",
      id: 1
    },
    {
      title: "Februari",
      shortTitle: "Feb",
      id: 2
    },
    {
      title: "Mars",
      shortTitle: "Mar",
      id: 3
    },
    {
      title: "April",
      shortTitle: "Apr",
      id: 4
    },
    {
      title: "Maj",
      shortTitle: "Maj",
      id: 5
    },
    {
      title: "Juni",
      shortTitle: "Jun",
      id: 6
    },
    {
      title: "Juli",
      shortTitle: "Jul",
      id: 7
    },
    {
      title: "Augusti",
      shortTitle: "Aug",
      id: 8
    },
    {
      title: "September",
      shortTitle: "Sep",
      id: 9
    },
    {
      title: "October",
      shortTitle: "Oct",
      id: 10
    },
    {
      title: "November",
      shortTitle: "Nov",
      id: 11
    },
    {
      title: "December",
      shortTitle: "Dec",
      id: 12
    }
  ],
  formOptions: [
    {
      label: "Januari",
      value: 1
    },
    {
      label: "Februari",
      value: 2
    },
    {
      label: "Mars",
      value: 3
    },
    {
      label: "April",
      value: 4
    },
    {
      label: "Maj",
      value: 5
    },
    {
      label: "Juni",
      value: 6
    },
    {
      label: "Juli",
      value: 7
    },
    {
      label: "Augusti",
      value: 8
    },
    {
      label: "September",
      value: 9
    },
    {
      label: "October",
      value: 10
    },
    {
      label: "November",
      value: 11
    },
    {
      label: "December",
      value: 12
    }
  ],
}

export default function cart(state=initialState, action){

  switch (action.type) {

    case 'CHANGE_MONTH':
      return {theMonth: action.monthId, months: [...state.months], formOptions: [...state.formOptions]};

    default:
      return state;

  }
}



// WEBPACK FOOTER //
// ./src/reducers/months.js